exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-sidebar[data-v-867e6f78]{position:sticky;top:16px}", ""]);

// exports
